module.exports = __webpack_public_path__ + "static/media/top-sport-icon.8a14dc4f.svg";